import { useState } from "react";

import useTranslations from "@/i18n/useTranslations";
import InfoIcon from "@/shared-components/icons/components/public/InfoIcon";
import Popup from '@/shared-components/popups/components/Popup';

import { ArtworkOfferPrice } from "../../components/ArtworkOfferElements";

export default function PaymentDetails({
  price,
  offerDetails = null,
  frameDetails = null,
  museumLabelDetails = null,
  shipping,
  vat = null,
  vatLabel = 'VAT',
  vatInfo = null,
  total,
}) {
  const t = useTranslations('common.shared.artwork_view.payment_details');
  const [vatInfoOpen, setVatInfoOpen] = useState(false);

  return (
    <>
      <div className="purchase-payment-details">
        <h3 className="purchase-info__details-heading">{t('heading')}</h3>
        <div className="purchase-info__detail-row">
          <p className="purchase-info__detail-label">{t('labels.price')}</p>
          <p className="purchase-info__detail-value">
            {offerDetails?.offerPrice !== null && offerDetails?.offerPrice !== undefined ? (
              <ArtworkOfferPrice
                originalPrice={offerDetails.originalPrice}
                offerPrice={offerDetails.offerPrice}
                currency={offerDetails.currency}
              />
            ) : (
              price
            )}
          </p>
        </div>
        {frameDetails ? (
          <div className="purchase-info__detail-row">
            <p className="purchase-info__detail-label">{frameDetails.label}</p>
            <p className="purchase-info__detail-value">{frameDetails.value}</p>
          </div>
        ) : null}
        {museumLabelDetails ? (
          <div className="purchase-info__detail-row">
            <p className="purchase-info__detail-label">{museumLabelDetails.label}</p>
            <p className="purchase-info__detail-value">{museumLabelDetails.value}</p>
          </div>
        ) : null}
        <div className="purchase-info__detail-row">
          <p className="purchase-info__detail-label">{t('labels.shipping')}</p>
          <p className="purchase-info__detail-value">{shipping}</p>
        </div>
        {vat ? (
          <div className="purchase-info__detail-row">
            <p className="purchase-info__detail-label purchase-info__detail-label--with-info">
              <span>{vatLabel}</span>
              {vatInfo ? (
                <span className="purchase-info__detail-info">
                  <button
                    type="button"
                    className="purchase-info__detail-info-button"
                    onClick={() => setVatInfoOpen(true)}
                    aria-label={t('labels.learn_more_vat')}
                    aria-expanded={vatInfoOpen}
                    aria-haspopup="dialog"
                  >
                    <InfoIcon className="purchase-info__detail-info-icon" />
                  </button>
                </span>
              ) : null}
            </p>
            <p className="purchase-info__detail-value">{vat}</p>
          </div>
        ) : null}
        <div className="purchase-info__detail-row total-row">
          <p className="purchase-info__detail-label">{t('labels.total')}</p>
          <p className="purchase-info__detail-value">{total}</p>
        </div>
      </div>

      <Popup
        open={vatInfoOpen}
        close={() => setVatInfoOpen(false)}
        title={vatLabel}
        className="generic-popup_content"
      >
        <div className="purchase-info__detail-info-popup-content">
          <p className="purchase-info__detail-info-popup-copy">{vatInfo}</p>
        </div>
      </Popup>
    </>
  );
}
